import I18n from '@module/i18n';
import PropTypes from 'prop-types';

const menu = (country, isConsentFlagActive) => {
  const links = [
    { href: '/legal/terms', label: 'Terms of Service' },
    { href: '/legal/privacy', label: 'Privacy & Cookie Statement' },
    { href: '/legal/takedown', label: 'Notice and Takedown Policy' },
    { href: '/legal/disclosure', label: 'Responsible Disclosure Policy' },
    { href: '/legal/advertising', label: 'Advertising Terms &\xa0Conditions' },
  ];

  const isCountryUS = country?.toUpperCase() === 'US';

  if (isConsentFlagActive) {
    links.splice(2, 0, {
      href: '/legal/manage-cookies',
      label: I18n.t('transfer.consent-manager.button-cookies-privacy'),
    });

    if (isCountryUS) {
      links.splice(3, 0, {
        href: '/legal/ccpa',
        label: I18n.t('transfer.consent-manager.button-ccpa'),
      });
    }
  }

  return links;
};

menu.propTypes = {
  country: PropTypes.string.isRequired,
  isConsentFlagActive: PropTypes.boolean,
};

menu.defaultProps = {
  isConsentFlagActive: false,
};

export default menu;
